import React, { Component } from "react";

import { BsyUtils } from "../../../utils/Utils";

import "./index.css";
import SearchDash from "./searchDash";
import BsySearchResult from "../../BsySearchResult";
import BsySLoading from "../../BsySLoading";
import BsySearchInput from "../../BsySearchInput";

export default class BsyDashboardMyDashConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: [],
      appMaps: {},
      customDash: props.customDash,
      dash: [...props.customDash.dash],
      key: "",
      seachList: [],
      isLoading: false,
    };
  }

  getAppList = () => {
    React.axios("/dashboard/app_group/list")
      .then((res) => {
        if (res.data.code === 0) {
          this.setState(
            {
              apps: [...res.data.items],
            },
            () => {
              // this.onSelectApp(this.state.appid);
            }
          );
        } else {
          BsyUtils.showAjaxTip(res.data, () => {
            this.setState(
              {
                apps: [...res.data.items],
              },
              () => {
                // this.onSelectApp(this.state.appid);
              }
            );
          });
        }
      })
      .catch((res) => {});
  };
  componentDidMount() {
    this.getAppList();
  }

  entryClick = (e) => {
    e.stopPropagation();
  };

  onSelectEntry = (entry) => {
    const { appMaps } = this.state;
    if (!entry) {
      return;
    }

    let _id = [entry.appId, entry.entryId].join("@");

    if (appMaps[_id]) {
      const newAppMap = {
        ...appMaps,
        [_id]: { ...appMaps[_id], open: !appMaps[_id].open },
      };
      this.setState({
        appMaps: newAppMap,
      });
      return;
    }
    this.setState({
      isLoading: true,
    });
    React.axios("/dashboard/app/" + entry.appId + "/entry/" + entry.entryId, {})
      .then((res) => {
        let components = [];

        // console.log(res.data.entry.components);
        BsyUtils.forEach(res.data.entry.components, (dd, data) => {
          if (!data) {
            return;
          }
          if (data.type.indexOf("filter") > -1) return;
          if (data.type.indexOf("filte_quick") > -1) return;
          if (data.type.indexOf("real_time") > -1) return;
          if (data.type.indexOf("base_layout_container") > -1) return;
          if (data.type.indexOf("description") > -1) return;
          if (
            data.type.indexOf("image") > -1 ||
            data.type.indexOf("gauge_imageMore") > -1
          )
            return;
          if (data.type.indexOf("embedded_iframe") > -1) return;

          components.push({
            ...data,
            appId: entry.appId,
            entryId: entry.entryId,
          });
        });

        const newAppMap = {
          [_id]: { components: components, open: true },
          ...appMaps,
        };
        this.setState({
          appMaps: newAppMap,
          isLoading: false,
        });
      })
      .catch((res) => {
        console.log(res);
        this.setState({
          isLoading: false,
        });
      });
  };

  onSelectApp = (_id) => {
    const { appMaps } = this.state;
    if (!_id) {
      return;
    }
    if (appMaps[_id]) {
      const newAppMap = {
        ...appMaps,
        [_id]: { ...appMaps[_id], open: !appMaps[_id].open },
      };
      this.setState({
        appMaps: newAppMap,
      });
      return;
    }
    this.setState({
      isLoading: true,
    });
    React.axios("/dashboard/app/" + _id, {})
      .then((res) => {
        let entrys = [];
        window.FX.STATIC.user.dock_userid = res.data.dock_userid;
        res.data.entryList.map((data, index) => {
          if (data.child) {
            BsyUtils.forEach(data.child, (index, childdata) => {
              entrys.push({ ...res.data.entryMap[childdata.id], appId: _id });
            });
            // data.child.map((childdata, index) => {
            //     entrys.push({ ...res.data.entryMap[childdata.id], appId: _id })
            // })
          } else {
            entrys.push({ ...res.data.entryMap[data.id], appId: _id });
          }
          return null;
        });
        const newAppMap = {
          [_id]: { ...res.data, entrys: entrys, open: true },
          ...appMaps,
        };
        this.setState({
          appMaps: newAppMap,
          isLoading: false,
        });
      })
      .catch((res) => {
        console.log(res);
        this.setState({
          isLoading: false,
        });
      });
  };

  getSearchValue = (ref) => {
    this.searchValue = ref;
  };

  onSearch = () => {
    let key = this.searchValue.getValue();
    if (!key) {
      this.setState({
        key: "",
        seachList: [],
      });
      return;
    }
    React.axios("/dashboard/search", {
      keyword: key,
      type: "entry",
      range: "noStandard",
    })
      .then((res) => {
        this.setState({
          key: this.searchValue.getValue(),
          seachList: res.data.list,
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };
  findEntryWidget = (block) => {
    const { dash } = this.state;

    let widget = dash.filter((data) => {
      if (
        [data.appId, data.entryId, data.widgetId].join("@") ===
        [block.appId, block.entryId, block.widgetId].join("@")
      ) {
        return true;
      }
      return false;
    });
    return widget.length > 0;
  };

  getValue = () => {
    const { customDash, dash } = this.state;
    if (this.props.getValue) {
      this.props.getValue({
        ...customDash,
        dash: [...dash],
      });
    }
  };

  renderComponentlist = (appInfo) => {
    const { appMaps } = this.state;

    let _id = [appInfo.appId, appInfo.entryId].join("@");

    if (appMaps[_id]) {
      if (!appMaps[_id].open) {
        return "";
      }

      let components = appMaps[_id].components;
      // console.log(components)
      return (
        <div className="dash-components">
          {components.length === 0 ? (
            <div className="components-item empty">
              <span className="entry-title">当前应用没有可使用报表</span>
            </div>
          ) : (
            components.map((data, index) => {
              return (
                <div
                  className={"components-item"}
                  onClick={(e) => {
                    e.stopPropagation();

                    if (this.findEntryWidget(data)) {
                      const dash = this.state.dash.filter((item) => {
                        return (
                          item.appId !== data.appId ||
                          item.entryId !== data.entryId ||
                          item.widgetId !== data.widgetId
                        );
                      });
                      this.setState(
                        {
                          dash: dash,
                        },
                        () => {
                          this.getValue();
                        }
                      );
                    } else {
                      this.setState(
                        {
                          dash: [
                            ...this.state.dash,
                            {
                              appId: data.appId,
                              entryId: data.entryId,
                              widgetId: data.widgetId,
                              width: data.width,
                              height: data.height,
                              type: data.type,
                              widgetParams: { ...data },
                            },
                          ],
                        },
                        () => {
                          this.getValue();
                        }
                      );
                    }
                  }}
                >
                  <span>
                    <i
                      className={`entry-icon ${BsyUtils._getWidgetTypeIcon(
                        data.type
                      )}`}
                    ></i>
                    <span className={"entry-title"}>
                      {data.title || data.listName}
                    </span>
                  </span>

                  <span className={"right-entry-title"}>
                    {this.findEntryWidget(data) ? (
                      <i className="icon-bsy-select" />
                    ) : (
                      <i className="icon-bsy-check2" />
                    )}
                  </span>
                </div>
              );
            })
          )}
        </div>
      );
    } else {
      return "";
    }
  };

  renderEntryList = (appInfo) => {
    const { appMaps } = this.state;
    if (appMaps[appInfo._id]) {
      if (!appMaps[appInfo._id].open) {
        return "";
      }

      let dashs = appMaps[appInfo._id].entrys.filter((data, index) => {
        return data.type === "dash";
      });

      console.log(dashs);

      return (
        <div className="app-entrys">
          {dashs.length === 0 ? (
            <div className="entry-item-title empty">
              <span className="entry-title">当前应用没有可使用报表</span>
            </div>
          ) : (
            dashs.map((data, index) => {
              if (data.type !== "dash") {
                return "";
              }
              return (
                <>
                  <div
                    className={"entry-item-title"}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.onSelectEntry(data);
                    }}
                  >
                    <i className={"entry-icon " + BsyUtils.getFormIcon(data)} />
                    <span className={"entry-title"}>{data.name}</span>
                  </div>
                  {this.renderComponentlist(data)}
                </>
              );
            })
          )}
        </div>
      );
    } else {
      return "";
    }
  };

  renderApplist = () => {
    const { apps } = this.state;
    let that = this;

    return (
      <>
        {apps.map((data) => {
          return data.apps.map((appdata) => {
            return (
              <div className={"applist-item "}>
                <div
                  className="app-title"
                  onClick={(e) => {
                    that.onSelectApp(appdata._id);
                  }}
                >
                  <div
                    className={"app-icon color-cover-" + appdata.style.color}
                  >
                    <div
                      className={
                        "imgbg-bsy-app imgbg-bsy-app-" + appdata.style.icon
                      }
                    />
                  </div>
                  <span>{appdata.appname}</span>
                </div>
                {this.renderEntryList(appdata)}
              </div>
            );
          });
        })}
      </>
    );
  };

  renderSeachlist = () => {
    const { seachList } = this.state;

    let dashs = seachList.filter((data) => {
      return data.type === "dash";
    });

    return (
      <div className="applist-item ">
        <div className="app-entrys">
          {dashs.length === 0 ? (
            <div className="entry-item-title empty">
              <span className="entry-title">未搜索到可使用报表</span>
            </div>
          ) : (
            dashs.map((data) => {
              return (
                <>
                  <div
                    className={"entry-item-title"}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.onSelectEntry(data);
                    }}
                  >
                    <i className={"entry-icon " + BsyUtils.getFormIcon(data)} />
                    <span className={"entry-title"}>{data.name}</span>
                  </div>
                  {this.renderComponentlist(data)}
                </>
              );
            })
          )}
        </div>
      </div>
    );
  };

  render() {
    const { key, block, isLoading } = this.state;
    return (
      <div className={"dashboard-custom-dash-config"}>
        <div className={"left-app-list"}>
          <div className="applist-seach">
            <BsySearchInput
              placeholder={React.language("form.search.placeholder")}
              getValue={this.getSearchValue}
              onSearch={this.onSearch}
              type={window.mode}
              // iconName="icon-bsy-reportmenu-0"
            />
          </div>
          <div className="applist">
            {!key ? this.renderApplist() : this.renderSeachlist()}
            {isLoading && <BsySLoading />}
          </div>
        </div>
      </div>
    );
  }
}
